import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { db } from "../services/firebase";
import { ref, get } from "firebase/database";
import "./InvitePage.css";

const InvitePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [inviterName, setInviterName] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    let from = params.get("from");
    if (!from || typeof from !== "string" || from.length > 32) {
      setError("Invalid invite link.");
      setTimeout(() => navigate("/"), 3000);
      return;
    }
    from = from.trim().toLowerCase();

    // Validate inviter exists in users (case-insensitive username/email)
    get(ref(db, "users")).then((snap) => {
      const users = snap.val() || {};
      const inviterUser = Object.values(users).find(
        (u) =>
          (u.username && u.username.trim().toLowerCase() === from) ||
          (u.email && u.email.trim().toLowerCase() === from)
      );
      // Optionally check for active status: && u.active !== false
      if (inviterUser) {
        setInviterName(
          inviterUser.name || inviterUser.username || inviterUser.email
        );
        localStorage.setItem("invitedBy", inviterUser.username);
        setTimeout(() => {
          navigate("/login");
        }, 5500);
      } else {
        setError("Inviter not found. The invite link is invalid or expired.");
        localStorage.removeItem("invitedBy");
        setTimeout(() => navigate("/"), 4500);
      }
    });
  }, [location, navigate]);

  if (error) {
    return (
      <div className="invite-wrapper">
        <div className="invite-message error">{error}</div>
      </div>
    );
  }

  return (
    <div className="invite-wrapper">
      <div className="invite-message">
        🎉 You're visiting from an invite by <strong>{inviterName}</strong>
      </div>
      <div className="spinner"></div>
    </div>
  );
};

export default InvitePage;
